<template>
  <v-app>
    <div id="blaueLeiste" :class="isLogin ? 'white' : 'primary'"></div>
    <v-navigation-drawer
      v-if="!isLogin"
      disable-resize-watcher
      app
      v-model="sideNav"
      :clipped="$vuetify.breakpoint.lgAndUp"
    >
      <v-list dense nav>
        <v-list-item
          class="hidden-sm-and-up"
          v-for="item in mainMenu"
          v-if="item.beta === false || $vars.beta"
          :key="item.title"
          :to="item.link"
          link
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/" class="hidden-xs-only">
          <v-list-item-icon>
            <v-icon>home</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="pb-1"></v-divider>
        <v-list-item v-for="item in sideMenu" :key="item.link" :to="item.link" link>
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-btn class="caption" disabled text block>Korpodesk {{ $vars.version }}</v-btn>
      <v-btn class="caption" disabled text block>{{ $vars.versionDatum }}</v-btn>
    </v-navigation-drawer>

    <v-navigation-drawer
      disable-resize-watcher
      right
      app
      v-model="showMenuMobile"
      :clipped="$vuetify.breakpoint.lgAndUp"
      width="90%"
    >
      <v-list-item>
        <v-avatar class="ma-2" color="primary" size="36" v-if="bild">
          <v-img :src="bild"></v-img>
        </v-avatar>
        <v-list-item-content>
          <v-list-item-title class="ml-2 headline">{{ name }}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn icon @click="showMenuMobile = false"><v-icon>close</v-icon></v-btn>
        </v-list-item-action>
      </v-list-item>
      <v-divider></v-divider>
      <v-list dense nav v-if="sideMenu.length === 0">
        <v-list-item
          class="hidden-sm-and-up"
          v-for="item in mainMenu"
          v-if="item.beta === false || $vars.beta"
          :key="item.title"
          :to="item.link"
          link
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list dense nav v-else>
        <v-list-item link to="/">
          <v-list-item-icon>
            <v-icon>home</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="pb-1"></v-divider>
        <v-list-item v-for="item in sideMenu" :key="item.link" :to="item.link" link>
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list dense nav>
        <v-divider class="pb-1"></v-divider>
        <v-list-item v-for="item in subMenu" :key="item.title" @click="goTo(item.link)">
          <v-avatar class="ma-2" color="primary" size="48" v-if="bild">
            <img :src="'/static/menu-icon/' + item.bild + '.png'" :alt="item.bild" />
          </v-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="pb-1"></v-divider>
        <v-list-item @click="showChargenUndAemter = true" v-if="this.$vars.verbindung === 'rbo'">
          <v-list-item-icon>
            <v-icon>groups</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Chargen & Ämter</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item @click="showHelp = true">
          <v-list-item-icon>
            <v-icon>help</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Hilfe</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- Menü nur für Admin -->
        <div v-if="$getCurrentBbr() === 'PBChUyAy7HWowQR4HlP3'">
          <v-divider></v-divider>
          <v-list-item @click="showEinstellungen = true">
            <v-list-item-icon>
              <v-icon>settings</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Einstellungen</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-chip label small class="green" dark>Admin</v-chip>
            </v-list-item-action>
          </v-list-item>
        </div>
        <!--  Bis hier hin Menü nur für Admin -->
        <v-divider></v-divider>
        <v-list-item @click="onLogout">
          <v-list-item-icon>
            <v-icon>exit_to_app</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Abmelden</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-card-actions class="justify-center grey--text">
          Korpodesk {{ $vars.version }} | {{ $filters.date($vars.versionDatum, "DD.MM.YYYY") }}
        </v-card-actions>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      v-if="!isLogin"
      class="primary"
      :dark="!isHomePage"
      app
      extended
      :fade-img-on-scroll="isHomePage"
      :shrink-on-scroll="isHomePage"
      :extension-height="extensionHeight"
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      :clipped-right="$vuetify.breakpoint.lgAndUp"
    >
      <!-- <v-btn @click="changeData()">ChangeData</v-btn> -->
      <!-- <v-btn @click="test()">Test</v-btn> -->

      <v-app-bar-nav-icon v-if="userIsAuthenticated && sideMenu.length > 0" class="hidden-xs-only"
        ><v-icon @click="toggleSideNav()">menu</v-icon></v-app-bar-nav-icon
      >
      <v-app-bar-nav-icon v-if="userIsAuthenticated" class="ml-1">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-chip label small class="green" dark v-on="on" v-if="$vars.beta">BETA</v-chip>
          </template>
          <span>
            <v-card class="transparent" flat dark width="200px">
              Dies ist die Betaversion von Korpodesk. Einige neue Funktionen sind dadurch verwendbar und werden mit dem
              grünen BETA Zeichen angekündigt.
            </v-card>
          </span>
        </v-tooltip>
      </v-app-bar-nav-icon>
      <v-app-bar-nav-icon v-if="$vars.beta" class="ml-4 mr-3">
        <v-chip label small class="green" dark>{{ $vars.verbindung }}</v-chip>
      </v-app-bar-nav-icon>

      <v-spacer class="hidden-sm-and-up"></v-spacer>
      <v-toolbar-title>{{ route }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <bundesbruderSucheShort
        class="hidden-sm-and-down"
        v-if="userIsAuthenticated"
        :dark="isHomePage"
      ></bundesbruderSucheShort>

      <v-tooltip bottom v-if="userIsAuthenticated">
        <template v-slot:activator="{ on }">
          <v-btn @click="goTo()" class="hidden-sm-and-down rounded-lg mx-1 mt-1" icon v-on="on"
            ><v-icon>home</v-icon></v-btn
          >
        </template>
        <span>Home</span>
      </v-tooltip>
      <!-- <v-tooltip bottom v-if='userIsAuthenticated'>
        <template v-slot:activator="{ on }">
          <v-btn icon @click='getToken()' v-on="on"><v-icon>notifications_none</v-icon></v-btn>
        </template>
        <span>Benachrichtigungen</span>
      </v-tooltip> -->

      <v-btn
        class="hidden-xs-only rounded-lg mt-1"
        icon
        v-if="userIsAuthenticated"
        @click="(showMenu = true) && getSubMenu()"
        ><v-icon>apps</v-icon></v-btn
      >
      <v-app-bar-nav-icon v-if="userIsAuthenticated" class="hidden-sm-and-up"
        ><v-icon @click="(showMenuMobile = true) && getSubMenu()">apps</v-icon></v-app-bar-nav-icon
      >

      <v-menu
        v-model="showMenu"
        absolute
        :position-x="x"
        :position-y="54"
        :min-width="subMenu.length > 12 ? '752px' : '376px'"
        :max-width="subMenu.length > 12 ? '752px' : '376px'"
        close-on-click
        max-height="calc(100vh - 90px)"
      >
        <v-card>
          <v-list-item>
            <v-avatar class="ma-2" color="primary" size="48" v-if="bild">
              <v-img :src="bild"></v-img>
            </v-avatar>
            <v-list-item-content>
              <v-list-item-title class="ml-2 headline">{{ name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-row class="pa-0 ma-0">
            <v-col
              :cols="subMenu.length > 12 ? 2 : 4"
              v-for="item in subMenu"
              :key="item.title"
              class="pa-0 ma-0 pt-1 pb-1 text-center"
            >
              <v-btn text width="110px" height="110px" @click="goTo(item.link)" class="text-center">
                <v-row class="pa-0 ma-0">
                  <v-col cols="12" class="pa-0 ma-0 pb-2">
                    <v-avatar :size="64" color="transparent">
                      <img :src="'/static/menu-icon/' + item.bild + '.png'" :alt="item.bild" />
                    </v-avatar>
                  </v-col>
                  <v-col cols="12" class="pa-0 ma-0">
                    <span class="caption font-weight-light">{{ item.title }}</span>
                  </v-col>
                </v-row>
              </v-btn>
            </v-col>
          </v-row>

          <v-list dense>
            <v-divider></v-divider>
            <v-list-item @click="showChargenUndAemter = true" v-if="this.$vars.verbindung === 'rbo'">
              <v-list-item-icon>
                <v-icon>groups</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Chargen & Ämter</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item @click="showHelp = true">
              <v-list-item-icon>
                <v-icon>help</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Hilfe</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <!-- Menü nur für Admin -->
            <div v-if="getAdmins.includes($getCurrentBbr()) || $getCurrentBbr() === 'PBChUyAy7HWowQR4HlP3'">
              <v-divider></v-divider>
              <v-list-item @click="showEinstellungen = true">
                <v-list-item-icon>
                  <v-icon>settings</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Einstellungen</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-chip label small class="green" dark>Admin</v-chip>
                </v-list-item-action>
              </v-list-item>
            </div>
            <!--  Bis hier hin Menü nur für Admin -->
            <v-divider></v-divider>
            <v-list-item @click="onLogout">
              <v-list-item-icon>
                <v-icon>exit_to_app</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Abmelden</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-card-actions class="justify-center grey--text"> Korpodesk {{ $vars.version }} </v-card-actions>
          </v-list>
        </v-card>
      </v-menu>

      <template v-slot:img v-if="isHomePage">
        <!-- PC -->
        <v-img contain :src="headerImage" height="200" class="white d-none d-md-flex">
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
            </v-row>
          </template>
        </v-img>
        <!-- Nur Tablet -->
        <v-img :src="headerImage" height="200" class="white hidden-xs-only hidden-lg-and-up"></v-img>
        <!-- Nur Handy -->
        <v-img :src="headerImage" height="132" class="white hidden-sm-and-up"></v-img>
      </template>

      <template v-slot:extension v-if="userIsAuthenticated">
        <v-row class="pa-0 ma-0 hidden-md-and-down">
          <v-col cols="12" class="pa-0 ma-0 text-center">
            <v-btn
              text
              class="mx-1 rounded-lg"
              :to="item.link"
              v-for="item in mainMenu"
              v-if="item.beta === false || $vars.beta"
              :key="item.title"
              :dark="isHomePage"
            >
              <span class="pl-2"
                >{{ item.title }}<br /><v-chip label class="green" x-small dark v-if="item.beta">BETA</v-chip></span
              >
            </v-btn>
            <!-- <v-tooltip bottom v-for='item in subMenu' :key='item.link'>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" text :to='item.link' >
                  <v-icon>{{ item.icon }}</v-icon>
                </v-btn>
              </template>
              <span>{{ item.title }}</span>
            </v-tooltip> -->
          </v-col>
        </v-row>
      </template>
    </v-app-bar>

    <v-main app class="grey lighten-4">
      <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>
      <router-view></router-view>
      <!-- <v-alert
        type="success"
      >
        Lieber Bundesbruder,<br>
        <br>
        ich arbeite gerade an der Datenarchitektur der Ripuarenapp.<br>
        Daher kann bis Freitag Vormittag nicht auf die App zugegriffen werden.<br>
        <br>
        Bei dringenden Fällen melde dich gerne direkt unter breuerbe@gmail.com<br>
        <br>
        Liebe bundesbrüderliche Grüße<br>
        Benedikt Breuer RBo!
      </v-alert> -->
    </v-main>

    <v-bottom-navigation v-if="userIsAuthenticated" app fixed color="primary" class="mb-4 hidden-sm-and-up">
      <!-- Footer Nav bei Smartphone und Tablet -->
      <v-btn to="/"><span>Home</span><v-icon>home</v-icon></v-btn>
      <v-btn to="/veranstaltungen"><span>Kalender</span><v-icon>event</v-icon></v-btn>
      <v-btn to="/bbrbbr"><span>BbrBbr</span><v-icon>group</v-icon></v-btn>
      <v-btn to="/rechnungen"><span>Rechnungen</span><v-icon>receipt_long</v-icon></v-btn>
    </v-bottom-navigation>
    <div id="weißeLeiste" class="white hidden-sm-and-up"></div>
    <v-bottom-navigation
      :shift="sideMenu.length > 8"
      v-if="userIsAuthenticated"
      app
      fixed
      class="hidden-lg-and-up hidden-xs-only"
      color="primary"
    >
      <!-- Footer Nav bei Tablet -->
      <v-btn v-for="item in mainMenu" :key="item.link" :to="item.link" v-if="sideMenu.length === 0">
        <span>{{ item.title }}</span>
        <v-icon>{{ item.icon }}</v-icon>
      </v-btn>
      <v-btn to="/" v-if="sideMenu.length > 0">
        <span>Home</span>
        <v-icon>home</v-icon>
      </v-btn>
      <v-divider vertical v-if="sideMenu.length > 0"></v-divider>
      <v-tooltip top v-for="item in sideMenu" :key="item.link">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" :to="item.link">
            <span>{{ item.title }}</span>
            <v-icon>{{ item.icon }}</v-icon>
          </v-btn>
        </template>
        <span>{{ item.title }}</span>
      </v-tooltip>
    </v-bottom-navigation>

    <einstellungen :visible.sync="showEinstellungen" @close="showEinstellungen = false"></einstellungen>

    <v-dialog v-model="showHelp" width="50%" :fullscreen="$vuetify.breakpoint.smAndDown" persistent scrollable>
      <v-card>
        <v-card-title>
          Hilfe
          <v-spacer></v-spacer>
          <v-btn icon @click="showHelp = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-alert>
            Du brauchst Hilfe oder hast einen Fehler gefunden? <br />
            Bitte beschreibe das Problem/den Fehler möglichst genau, sodass ich dir Helfen oder die Funktion verbessern
            kann. Vielen Dank!
          </v-alert>
          <v-text-field v-model="fehler.seite" label="Auf welcher Seite tritt der Fehler auf?" outlined></v-text-field>
          <v-textarea v-model="fehler.beschreibung" label="Beschreibung" outlined></v-textarea>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showHelp = false">Abbrechen</v-btn>
          <v-btn class="primary" @click="sendFehler()" text>Senden</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showChargenUndAemter"
      width="100%"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title>
          Chargen & Ämter
          <v-spacer></v-spacer>
          <v-btn icon @click="showChargenUndAemter = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-0 ma-0">
          <v-row no-gutters class="hidden-sm-and-down">
            <v-col cols="12" md="6" lg="3" class="pa-1">
              <chargen vorstand="Chargen" :showTitle="true" class="mt-2 pb-1"></chargen>
            </v-col>
            <v-col cols="12" md="6" lg="3" class="pa-1">
              <chargen vorstand="AHV-Vorstand" :showTitle="true" class="mt-2 pb-1"></chargen>
              <chargen vorstand="HBV-Vorstand" :showTitle="true" class="mt-2 pb-1"></chargen>
            </v-col>
            <v-col cols="12" md="6" lg="3" class="pa-1">
              <chargen vorstand="Kommissionen" :showTitle="true" class="mt-2 pb-1"></chargen>
              <chargen vorstand="Zirkel" :showTitle="true" class="mt-2 pb-1"></chargen>
            </v-col>
            <v-col cols="12" md="6" lg="3" class="pa-1">
              <chargen vorstand="Ämter" :showTitle="true" class="mt-2 pb-1"></chargen>
            </v-col>
          </v-row>
          <v-row class="hidden-md-and-up">
            <v-col cols="12">
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header class="title">Chargen Aktivitas</v-expansion-panel-header>
                  <v-expansion-panel-content
                    ><chargen :showTitle="false" vorstand="Aktivitas" class="mt-2 pb-1"></chargen
                  ></v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="title">Chargen AHV</v-expansion-panel-header>
                  <v-expansion-panel-content
                    ><chargen :showTitle="false" vorstand="AHV-Vorstand" class="mt-2 pb-1"></chargen
                  ></v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="title">Chargen HBV</v-expansion-panel-header>
                  <v-expansion-panel-content
                    ><chargen :showTitle="false" vorstand="HBV-Vorstand" class="mt-2 pb-1"></chargen
                  ></v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="title">Kommissionen</v-expansion-panel-header>
                  <v-expansion-panel-content
                    ><chargen :showTitle="false" vorstand="Kommissionen" class="mt-2 pb-1"></chargen
                  ></v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="title">Zirkel</v-expansion-panel-header>
                  <v-expansion-panel-content
                    ><chargen :showTitle="false" vorstand="Zirkel" class="mt-2 pb-1"></chargen
                  ></v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="title">Ämter</v-expansion-panel-header>
                  <v-expansion-panel-content
                    ><chargen :showTitle="false" vorstand="Ämter" class="mt-2 pb-1"></chargen
                  ></v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="mb-6 mb-md-0">
          <v-spacer></v-spacer>
          <v-btn text @click="showChargenUndAemter = false">Schließen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <dialogNachricht></dialogNachricht>
    <snackbar></snackbar>
    <dialogError></dialogError>
    <!-- <v-dialog
      fullscreen
      v-model="showLoadingDialog"
      overlay-color="white"
      overlay-opacity="1"
    >
      <v-card class="d-flex justify-center align-center">
        <span class="d-flex justify-center align-center">
          <v-progress-circular
            size="200"
            :value="loadingValue"
            :rotate="-90"
            width="16"
            color="primary"
          >
          </v-progress-circular>
        </span>
      </v-card>
    </v-dialog> -->
  </v-app>
</template>

<script>
  import dialogNachricht from "@/module/submodule/dialogNachricht";
  import snackbar from "@/module/submodule/snackbar";
  import dialogError from "@/module/submodule/dialogError";
  import firebase from "firebase/compat/app";
  import "firebase/compat/firestore";
  export default {
    components: {
      dialogNachricht,
      snackbar,
      dialogError,
    },
    data() {
      return {
        loadingValue: 0,
        showLoadingDialog: true,
        showSuche: false,
        showEinstellungen: false,
        suche: "",
        showMenu: false,
        showChargenUndAemter: false,
        showMenuMobile: false,
        showNeueNachricht: false,
        sucheAnzeigen: false,
        showStartDialog: false,
        menuItems: [],
        showHelp: false,
        fehler: [],
        name: "",
        message: {
          titel: "",
          body: "",
        },
        subMenu: [],
        sideNavItem: true,
        sideNav: false,
        footerMenu: [],
        kontakte: [],
        bild: "",
      };
    },
    computed: {
      x() {
        if (this.$vuetify.breakpoint.name === "sm" || this.$vuetify.breakpoint.name === "xs") {
          return (window.innerWidth - 367) / 2;
        } else {
          return window.innerWidth - 367 - 16;
        }
      },
      bbrbbr() {
        return this.$store.state.bbrbbr.bbrbbr;
      },
      einstellungen() {
        return this.$store.state.einstellungen.einstellungen;
      },
      mainMenu() {
        let mitglieder = "";
        if (this.$store.getters["einstellungen/einstellung"]("allgemein")) {
          mitglieder = this.$store.getters["einstellungen/einstellung"]("allgemein").bezMitglieder;
        }
        let allgemein = this.$store.getters["einstellungen/einstellung"]("allgemein");
        let menu = [{ icon: "home", beta: false, title: "Home", link: "/" }];
        // {icon: 'cake', beta: false, title: '160. Stiftungsfest', link: '/160jahre'},
        // {icon: 'cake', beta: false, title: 'Ripuarentage', link: '/ripuarentage'},
        if (allgemein) {
          this.showLoadingDialog = false;
          if (allgemein.showMenuVeranstaltungen) {
            menu.push({ icon: "event", beta: false, title: "Veranstaltungen", link: "/veranstaltungen" });
          }
          if (allgemein.showMenuKontakte) {
            menu.push({ icon: "groups", beta: false, title: mitglieder, link: "/bbrbbr" });
          }
          if (allgemein.showMenuRechnungen) {
            menu.push({ icon: "receipt_long", beta: false, title: "Rechnungen", link: "/rechnungen" });
          }
          if (allgemein.showMenuKontaktdaten) {
            menu.push({ icon: "person", beta: false, title: "Kontaktdaten", link: "/daten" });
          }
          if (allgemein.showMenuDownload) {
            menu.push({ icon: "download", beta: false, title: "Download", link: "/download" });
          }
          if (allgemein.showMenuSemester) {
            menu.push({ icon: "event_repeat", beta: true, title: "Semester", link: "/semester" });
          }
          if (allgemein.showMenuStammbaum) {
            menu.push({ icon: "diversity_3", beta: false, title: "Stammbaum", link: "/stammbaum/home" });
          }
        }
        return menu;
      },
      headerImage() {
        const allgemeinEinstellung = this.$store.getters["einstellungen/einstellung"]("allgemein");
        return allgemeinEinstellung ? allgemeinEinstellung.header : null;
      },
      seiten() {
        let seiten = [];
        if (this.$store.state.einstellungen.einstellungen.length > 0) {
          let items = this.$store.getters["einstellungen/einstellung"]("rollen");
          if (items !== undefined) {
            items.seiten.forEach((item) => {
              seiten.push({
                text: item.titel,
                bild: item.bild,
                link: "/modul/" + item.titel + "/uebersicht",
                berechtigt: item.berechtigt,
                module: item.module,
              });
            });
          }
        }
        return seiten;
      },
      sideMenu() {
        let menu = [];
        let link = this.$route.params.seite;
        if (link && this.seiten.length > 0) {
          let seite = this.seiten.find((modul) => modul.text === link);
          seite.module.forEach((modul) => {
            menu.push({ icon: modul.icon, title: modul.name, link: "/modul/" + seite.text + "/" + modul.value });
          });
        }
        return menu;
      },
      extensionHeight() {
        if (this.userIsAuthenticated) {
          if (this.isHomePage) {
            if (this.$vuetify.breakpoint.name === "md" || this.$vuetify.breakpoint.name === "sm") {
              return 32;
            } else {
              if (this.$vuetify.breakpoint.name === "xs") {
                return 0;
              } else {
                return 68;
              }
            }
          } else {
            if (this.$vuetify.breakpoint.name === "md" || this.$vuetify.breakpoint.name === "sm") {
              return 0;
            } else {
              if (this.$vuetify.breakpoint.name === "xs") {
                return 0;
              } else {
                return 48;
              }
            }
          }
        } else {
          return 0;
        }
      },
      isLogin() {
        return (
          this.$route.name === "Anmelden" ||
          this.$route.name === "Registrieren" ||
          this.$route.name === "Passwort vergessen"
        );
      },
      isHomePage() {
        return (
          this.$route.name === "Ripuaria" ||
          this.$route.name === "Korpodesk" ||
          this.$route.name === "160. Stiftungsfest" ||
          this.$route.name === "Ripuarentage"
        );
      },
      route() {
        let nichtAnzeigen = [
          "160. Stiftungsfest",
          "Sommerfest",
          "Korpodesk",
          "Ripuarentage",
          "Anmelden",
          "Registrieren",
          "Passwort vergessen",
          "Home",
          "Mitglieder",
          "Ripuaria",
          "Veranstaltungen",
          "Mail",
          "Forum",
          "Rechnungen",
          "Download",
          "Bundesbrüder",
          "Daten",
          "Stammbaum",
          "Stammbaum - Daten",
          "Semester",
          "Mailadresse verifizieren",
          "Mailadresse ändern",
          "Anleitungen",
          "Setup",
        ];
        if (nichtAnzeigen.indexOf(this.$route.name) > -1) {
          this.sideNav = false;
        } else {
          switch (this.$vuetify.breakpoint.name) {
            case "xs":
              this.sideNav = false;
              break;
            case "sm":
              this.sideNav = false;
              break;
            case "md":
              this.sideNav = false;
              break;
            case "lg":
              this.sideNav = true;
              break;
            case "xl":
              this.sideNav = true;
              break;
          }
        }
        if (this.$route.params.seite === undefined) {
          if (
            this.$route.name === "Ripuaria" ||
            this.$route.name === "Korpodesk" ||
            this.$route.name === "160. Stiftungsfest" ||
            this.$route.name === "Ripuarentage"
          ) {
            return;
          } else {
            return this.$route.name;
          }
        } else {
          return this.$route.params.seite;
        }
      },
      userIsAuthenticated() {
        return (
          this.$store.state.user.user !== null &&
          this.$store.state.user.user !== undefined &&
          this.$firebase.auth().currentUser.emailVerified
        );
      },
      getAdmins() {
        return this.$store.getters["einstellungen/einstellung"]("allgemein").admins;
      },
    },
    methods: {
      async userIsVerified() {
        const user = this.$firebase.auth().currentUser;
        const token = await user.getIdToken();
        console.log(token);
        return this.$firebase.auth().currentUser ? this.$firebase.auth().currentUser.emailVerified : false;
      },
      changeData() {
        console.log("Change Data");
        const collection = "einstellungen";
        firebase
          .firestore()
          .collection(collection)
          .onSnapshot(
            (snapshot) => {
              let items = [];
              snapshot.forEach((doc) => {
                items.push({
                  ...doc.data(),
                  id: doc.id,
                });
              });
              console.log(items);
              // items.forEach(item => {
              //   firebase.firestore().collection('vereine').doc('test').collection(collection).doc(item.id).set(item)
              //     .then(() => {
              //       console.log('success')
              //     })
              //     .catch((error) => {
              //       console.log(error)
              //     })
              // })
            },
            (error) => {
              console.log(error);
            }
          );
      },
      test() {
        firebase
          .firestore()
          .collection("vereine")
          .doc("rbo")
          .collection("kontakte")
          .onSnapshot(
            (snapshot) => {
              let items = [];
              snapshot.forEach((doc) => {
                if (doc.data().anmeldeID) {
                  items.push({
                    ...doc.data(),
                    id: doc.id,
                  });
                }
              });
              items.forEach((item) => {
                let field = {
                  email: item.email,
                  id: item.anmeldeID,
                  vereine: ["rbo"],
                };
                console.log(field);
                firebase
                  .firestore()
                  .collection("user")
                  .doc(item.anmeldeID)
                  .set(field)
                  .then(() => {
                    console.log("success");
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              });
              console.log(items);
            },
            (error) => {
              console.log(error);
            }
          );
      },
      getToken() {
        this.$messaging
          .getToken({
            vapidKey:
              "AAAAa2TXeCg:APA91bF-Ybz-2aMOpR74NdfD-X1Ks3PFvB5eX7OsKku0HG0XUSeQt6J-VwUzsJAaOyeMOXWPmjdLu8U3pcsXvBgBC57jCJtcHJKtXblqsyz6ZxX4taLenR10zX7x2P2oXgCNi9iQbbKk",
          })
          .then((currentToken) => {
            if (currentToken) {
              // Send the token to your server and update the UI if necessary
              console.log(currentToken);
              this.getCurrentBbr();
              let bbr = this.$store.getters["bbrbbr/bbr"](this.currentBbr);
              console.log(this.currentBbr);
              console.log(bbr);
              if (!bbr.notificationToken) {
                bbr.notificationToken = [];
              }
              console.log(bbr.notificationToken.indexOf(currentToken));
              if (bbr.notificationToken.indexOf(currentToken) === -1) {
                bbr.notificationToken.push(currentToken);
                this.$store.dispatch("bbrbbr/updateBbrData", bbr);
              }
              // ...
            } else {
              // Show permission request UI
              console.log("No registration token available. Request permission to generate one.");
              // ...
            }
          })
          .catch((err) => {
            console.log("Test: An error occurred while retrieving token. ", err);
            // ...
          });
      },
      getSubMenu() {
        let menu = [];
        this.seiten.forEach((item) => {
          if (item.berechtigt.indexOf(this.$getCurrentBbr()) >= 0 || this.$getCurrentBbr() === "PBChUyAy7HWowQR4HlP3") {
            menu.push({ icon: "group", title: item.text, link: item.link, bild: item.bild });
          }
        });
        this.subMenu = menu;
      },
      currentBbr() {
        return this.$getCurrentBbr();
      },
      sendFehler() {
        let betreff = "Fehler/Problem auf Korpodesk";
        let text = this.fehler.beschreibung.replace(/(?:\r\n|\r|\n)/g, "<br>");
        let absender = this.$store.getters["bbrbbr/bbr"](this.$getCurrentBbr());
        console.log(this.$getCurrentBbr());
        let to = [];
        to.push("breuerbe@gmail.com");
        this.$store.dispatch("mails/createEinMails", {
          art: "mail",
          to,
          an: "Benedikt Breuer",
          absender: {
            position: "" || "",
            name: absender.vorname || "" + " " + absender.nachname || "",
            adresse: absender.adresse || "",
            plz: absender.plz || "",
            ort: absender.ort || "",
            email: absender.email || "",
            telefon: absender.handy || "",
          },
          message: {
            subject: betreff,
            text: text,
          },
          datum: new Date(),
        });
        this.showFehler = false;
        this.fehler = [];
      },
      toggleSideNav() {
        this.sideNav = !this.sideNav;
      },
      toggleSideNavRight() {
        this.showMenuMobile = !this.showMenuMobile;
      },
      goTo(link) {
        this.showMenu = false;
        this.showMenuMobile = false;
        link ? this.$router.push(link) : this.$router.push("/");
      },
      onLogout() {
        this.menuItems = [{ icon: "lock_open", bild: "mitglieder.png", title: "Anmelden", link: "/anmelden" }];
        this.$store.dispatch("user/logout");
        this.$router.push("/anmelden");
      },
      onResize() {
        this.showMenu = false;
      },
    },
    updated() {
      if (this.$firebase.auth().currentUser && this.userIsAuthenticated) {
        let name;
        let bild;
        this.$store.state.bbrbbr.bbrbbr.forEach((item) => {
          if (item.anmeldeID === this.$firebase.auth().currentUser.uid) {
            name = item.nachname + ", " + item.vorname;
            bild = item.bildAhnengalerie;
          }
        });
        this.name = name;
        this.bild = bild;
      }
      let settings = this.$store.getters["einstellungen/einstellung"]("allgemein");
      // console.log('settings')
      // console.log(settings)
      if (settings) {
        // Überprüfung und Zuweisung für primary
        if (typeof settings.primary === "string") {
          this.$vuetify.theme.themes.light.primary = settings.primary;
        } else {
          this.$vuetify.theme.themes.light.primary = settings.primary.hex;
        }

        // Überprüfung und Zuweisung für secondary
        if (typeof settings.secondary === "string") {
          this.$vuetify.theme.themes.light.secondary = settings.secondary;
        } else {
          this.$vuetify.theme.themes.light.secondary = settings.secondary.hex;
        }

        // Überprüfung und Zuweisung für tertiary
        if (typeof settings.tertiary === "string") {
          this.$vuetify.theme.themes.light.tertiary = settings.tertiary;
        } else {
          this.$vuetify.theme.themes.light.tertiary = settings.tertiary.hex;
        }
      }
      // this.$vuetify.theme.themes.light.primary = '#4caf50'
      // console.log(this.$vuetify.theme.themes.light)
    },
    async mounted() {
      if (window.location.hostname === "rbo-system.web.app") {
        window.location.href = "https://rbo.korpodesk.de";
      }
      let sub = window.location.hostname.split(".")[0];
      this.$vars.verbindung = sub;
      this.$vars.beta = false;
      if (sub === "localhost" || sub === "beta") {
        this.$vars.beta = true;
        this.$vars.verbindung = "rbo";
      }
      if (window.location.hostname.split(".")[1] === "localhost") {
        this.$vars.beta = true;
      }
      if (sub === "test") {
        this.$vars.beta = true;
      }
      window.addEventListener("resize", this.onResize);
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.onResize);
    },
    beforeMount() {
      function randomInterval(min, max) {
        return Math.random() * (max - min) + min;
      }
      setInterval(() => {
        if (this.loadingValue < 100) {
          this.loadingValue = Math.min(this.loadingValue + parseInt((Math.random(0, 1) * 10).toFixed(0)), 100);
        } else {
          this.loadingValue = 100;
          this.showLoadingDialog = false;
        }
      }, randomInterval(150, 250));
      this.getSubMenu();
      if (this.$firebase.auth().currentUser) {
        this.$firebase
          .firestore()
          .collection("vereine")
          .doc(this.$vars.verbindung)
          .collection("einstellungen")
          .doc("mitgliederstatus")
          .get()
          .then((doc) => {
            let alleStatus = doc.data().status;
            alleStatus.forEach((status) => {
              this.kontakte.push({ icon: "group", title: status.status, link: "/bbrbbr/" + status.status });
            });
          })
          .catch((err) => {
            console.log("Error getting document", err);
          });
      }
    },
  };
</script>

<style lang="stylus">
  @import url('https://fonts.googleapis.com/css? family=Ubuntu:300,400,700&display=swap');

  .v-application {
    font-family: 'Ubuntu', 'Roboto', sans-serif !important;
    font-weight: normal;
    font-style: normal;
  }

  html{
    overflow: auto;
    height: 100vh;
  }

  body {
    margin-top: constant(safe-area-inset-top);
    margin-top: env(safe-area-inset-top);
    margin-bottom: calc(4px + env(safe-area-inset-top));
  }

  ::-webkit-scrollbar {
    width: 8px;
    background: #F6F6F6;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
  }

  ::-webkit-scrollbar-thumb {
    background: #404040;
    border-radius: 4px;
  }

  .toolbar-menu{
    z-index: 100;
  }
  .navigation-menu{
    padding-top: 64px;
  }
  .container--fluid{
    padding: 0px;
  }
  .row{
    margin-left: 8px;
    margin-right: 8px;
  }
  #blaueLeiste{
    position: fixed;
    top: -100px;
    left: 0px;
    width: 100%;
    height: 100px;
    z-index: 2000;
  }

  #weißeLeiste{
    position: fixed;
    bottom: 0px;
    left: 0px;
    width: 100%;
    height: 24px;
    z-index: 2000;
  }

  .loader{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 10px;
    margin-top: 0;
    z-index: 10;
  }
</style>



// WEBPACK FOOTER //
// App.vue?426022b3